import { Modal, ModalProps } from '@ds';

export const DrawerModal = ({ classNames, ...props }: ModalProps) => {
  return (
    <Modal
      size="md"
      classNames={{
        wrapper: 'justify-end',
        body: 'flex-1 h-auto overflow-auto py-3',
        base: 'h-screen m-0! rounded-s-lg rounded-e-none',
        footer: 'flex flex-col gap-4',
        ...classNames,
      }}
      motionProps={{
        variants: {
          enter: {
            x: 0,
            opacity: 1,
            transition: {
              duration: 0.2,
              ease: 'easeOut',
            },
          },
          exit: {
            x: 60,
            opacity: 0,
            transition: {
              duration: 0.2,
              ease: 'easeIn',
            },
          },
        },
      }}
      {...props}
    />
  );
};
